module.exports = __webpack_public_path__ + "img/partnerList.f0462034.png";